import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Twitter } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const services = [
  { slug: 'fiber-optic', name: 'Fiber Optics' },
  { slug: 'cctv-systems', name: 'CCTV Systems' },
  { slug: 'structured-cabling', name: 'Structured Cabling' },
  { slug: 'access-control', name: 'Access Control' },
  { slug: 'networking', name: 'Networking' },
  { slug: 'alarm-systems', name: 'Alarm Systems' },
  { slug: 'data-centers', name: 'Data Centers' },
];

const cities = [
  { slug: 'orlando', name: 'Orlando' },
  { slug: 'miami', name: 'Miami' },
  { slug: 'tampa', name: 'Tampa' },
  { slug: 'jacksonville', name: 'Jacksonville' },
  { slug: 'west-palm-beach', name: 'West Palm Beach' },
  { slug: 'naples', name: 'Naples' },
];

export default function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#003366' }} className="border-t border-white/10">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2" data-testid="footer-logo">
              <img 
                src="/logo-iqes-new.png" 
                alt="IQES Low Voltage" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex gap-3 pt-2">
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors text-white" data-testid="social-linkedin">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors text-white" data-testid="social-facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors text-white" data-testid="social-twitter">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-white/70 text-sm hover:text-[#00A651] transition-colors"
                    data-testid={`footer-service-${service.slug}`}
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">{t('footer.locations')}</h4>
            <ul className="space-y-2">
              {cities.map((city) => (
                <li key={city.slug}>
                  <Link
                    to={`/locations/${city.slug}`}
                    className="text-white/70 text-sm hover:text-[#00A651] transition-colors"
                    data-testid={`footer-city-${city.slug}`}
                  >
                    {city.name}, FL
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#00A651] mt-1 flex-shrink-0" />
                <a href="tel:+17869813760" className="text-white/70 text-sm hover:text-[#00A651] transition-colors">
                  (786) 574-2905
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#00A651] mt-1 flex-shrink-0" />
                <a href="mailto:info@iqeslowvoltage.com" className="text-white/70 text-sm hover:text-[#00A651] transition-colors">
                  info@iqeslowvoltage.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#00A651] mt-1 flex-shrink-0" />
                <span className="text-white/70 text-sm">
                  Florida, USA<br />
                  Serving All Major Cities
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm">
            © {currentYear} IQES. {t('footer.rights')}
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-white/70 text-sm hover:text-[#00A651] transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white/70 text-sm hover:text-[#00A651] transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
